import { render, staticRenderFns } from "./LetterTemplates.vue?vue&type=template&id=b7cc09c0&scoped=true"
import script from "./LetterTemplates.vue?vue&type=script&lang=js"
export * from "./LetterTemplates.vue?vue&type=script&lang=js"
import style0 from "./LetterTemplates.vue?vue&type=style&index=0&id=b7cc09c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cc09c0",
  null
  
)

export default component.exports